import { defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "as-d-flex as-flex-column as-box-match-info" }
const _hoisted_2 = { class: "as-icon" }
const _hoisted_3 = ["src"]
const _hoisted_4 = {
  key: 1,
  class: "as-icon",
  width: "37",
  height: "37",
  viewBox: "0 0 37 37",
  "aria-hidden": "true"
}
const _hoisted_5 = ["xlink:href"]
const _hoisted_6 = { class: "as-info" }
const _hoisted_7 = { class: "as-name" }
const _hoisted_8 = { class: "as-nation" }
const _hoisted_9 = { key: 0 }
const _hoisted_10 = ["src", "alt"]

import { computed, getCurrentInstance } from "vue";
import type { IMatch } from "~src/interfaces";
import InformationIcon from "~src/components/matches/InformationIcon.vue";


const __default__ = {};

interface IProps {
  match: IMatch;
}


export default /*@__PURE__*/_defineComponent({
  ...__default__,
  __name: 'Information',
  props: {
    match: {}
  },
  setup(__props: any) {

const props = __props;

const args = computed(() => {
  const instance: any = getCurrentInstance();
  const data = {
    league: {
      icon:  instance.proxy?.getImgUrlBySport("competition", props.match.competition_id),
      name: "Giải đấu",
      value:
        props.match.competition?.name !== ""
          ? props.match.competition?.name
          : null,
    },
  } as { [key: string]: any };

  if (props.match.round?.round_num) {
    data.round = {
      icon: "iconround",
      name: "Vòng thi đấu",
      value:
        props.match.round?.round_num !== 0
          ? props.match.round?.round_num
          : null,
    };
  }
  if (props.match.venue?.name) {
    data.stadium = {
      icon: "iconstadium",
      name: "Sân vận động",
      value: props.match.venue?.name,
    };
  }
  if (props.match.environment?.temperature) {
    data.temperature = {
      icon: "icontemperature",
      name: "Nhiệt độ",
      value: props.match.environment?.temperature,
    };
  }
  if (props.match.referee?.name) {
    data.referee = {
      icon: "iconreferee",
      name: "Trọng tài",
      value: props.match.referee?.name,
      country_id: props.match.referee?.country_id,
      yellow_card_percent: props.match.referee?.yellow_card_percent,
      red_card_percent: props.match.referee?.red_card_percent,
    };
  }

  if (props.match.coach && props.match.coach.home) {
    data.coach_home = {
      icon: "iconOachHome",
      name: "HLV đội chủ",
      value: props.match.coach.home.name,
    };
  }

  if (props.match.coach && props.match.coach.away) {
    data.coach_away = {
      icon: "iconOachAway",
      name: "HLV đội khách",
      value: props.match.coach.away.name,
    };
  }

  return data;
});

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(InformationIcon),
    _createElementVNode("div", _hoisted_1, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(args.value, (arg, key) => {
        return (_openBlock(), _createElementBlock("div", {
          key: key,
          class: "as-item as-d-flex as-align-items-center"
        }, [
          _createElementVNode("div", _hoisted_2, [
            (key === 'league')
              ? (_openBlock(), _createElementBlock("img", {
                  key: 0,
                  src: arg.icon,
                  class: "as-icon",
                  width: "37",
                  height: "37"
                }, null, 8, _hoisted_3))
              : (_openBlock(), _createElementBlock("svg", _hoisted_4, [
                  _createElementVNode("use", {
                    "xlink:href": '#' + arg.icon
                  }, null, 8, _hoisted_5)
                ]))
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createElementVNode("div", _hoisted_7, _toDisplayString(arg.name), 1),
            _createElementVNode("div", _hoisted_8, [
              _createTextVNode(_toDisplayString(arg.value) + " ", 1),
              (key == 'referee' && arg.country_id)
                ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                    _createElementVNode("img", {
                      src: _ctx.getImgUrlBySport('country', arg.country_id),
                      alt: arg.name
                    }, null, 8, _hoisted_10)
                  ]))
                : _createCommentVNode("", true)
            ])
          ])
        ]))
      }), 128))
    ])
  ], 64))
}
}

})